import React, { useState } from "react";

// import { Container } from './styles';

interface SelectButtonProps {
  title?: string;
  buttons: {
    title: string;
    value?: string;
  }[];
  buttonWidth?: number | "max";
  flex?: number;
  height?: number | string;
  unselectable?: boolean;
  defaultValue?: string;

  disabled?: boolean;

  onSelect(value: string): void;
}

const SelectButtons: React.FC<SelectButtonProps> = (props) => {
  const [selected, setSelected] = useState(props.defaultValue ?? "");

  function select(e: React.MouseEvent<HTMLButtonElement>) {
    if (props.disabled) return;
    const { name } = e.currentTarget;

    const _name = props.unselectable && selected === name ? "" : name;

    setSelected(_name);
    props.onSelect(_name);
  }
  return (
    <div className={`flex flex-col${props.flex ? ` flex-${props.flex}` : ""}`}>
      {props.title && <p className="py-1.5 text-xs">{props.title}</p>}
      <div
        className={`flex${props.flex ? ` flex-${props.flex}` : ""}`}
        style={{ height: props.height ?? 40 }}
      >
        {props.buttons.map((e, i) => {
          const value = e.value ?? e.title;
          const isSelected = selected === value;
          const isFirst = i === 0;
          const isLast = i === props.buttons.length - 1;
          return (
            <button
              name={value}
              key={"selb" + i}
              onClick={select}
              disabled={props.disabled}
              className={[
                "flex flex-1 cursor-pointer items-center justify-center border border-gray-500 font-semibold transition-colors",
                "bg-white hover:bg-gray-100",
                isSelected ? "bg-black/10" : "",
                isFirst ? "rounded-l-md border-r-0" : "",
                isLast ? "rounded-r-md border-l-0" : "",
                !isFirst && !isLast ? "border-l-0 border-r-0" : "",
                props.disabled ? "cursor-not-allowed opacity-50" : "",
              ].join(" ")}
              style={{
                flex: props.flex,
                width: props.buttonWidth === "max" ? "100%" : props.buttonWidth,
                height: "100%",
              }}
            >
              <p className="px-1.5 text-xs">{e.title}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SelectButtons;
